import React from 'react';
import moment from 'moment';

import { DataGrid, GridValueGetterParams } from '@mui/x-data-grid';
import { Container, Button, Grid, Stack, Typography } from '@mui/material';

import * as Api from "api";
import * as PaymentApi from 'api/payments'
import ErrorMessage from 'tsui/ErrorMessage'
import RefundDialog from '../cards/RefundDialog';

export class PaymentsData {
    paymentId: string;
    paymentDate: Date;
    userId: string;
    cardType: string;
    cardsCount: number;
    paymentStatus: string;
    amount: number;
    currency: string
    arcaPaymentStatus?: string;
    ameriaOrderStatus?: string;
    ameriaResponseCode?: string;


    constructor(p: PaymentApi.ApiPayments) {
        this.paymentId = p.paymentId;
        this.cardType = p.cardType;
        this.paymentDate = p.paymentDate;
        this.cardsCount = p.cardsCount
        this.userId = p.userId
        this.paymentStatus = p.paymentStatus
        this.amount = p.amount
        this.currency = p.currency
        // this.arcaPaymentStatus = p.arcaPaymentStatus
        this.ameriaOrderStatus = p.ameriaOrderStatus
        this.ameriaResponseCode = p.ameriaResponseCode



    }
}

export default function PaymentsTab() {

    const mounted = React.useRef(false);
    const [dataRequested, setDataRequested] = React.useState(false);
    let [error, setError] = React.useState<Error | null>(null);
    const [payments, setPayments] = React.useState<PaymentsData[] | null>(null);
    let [cardDetailsId, setCardDetailsId] = React.useState<string | null>(null);
    let [showAddUser, setShowAddUser] = React.useState(false);
    let [refundPayment, setRefundPayment] = React.useState<string | null>(null);

    React.useEffect(() => {
        mounted.current = true;
        if (!dataRequested) {
            Api.requestAdmin<PaymentApi.ApiPayments[]>('payments', 'fetch', {}).then(payments => {
                if (mounted.current) {
                    let paymentsData: PaymentsData[] = [];
                    for (let p of payments) {
                        console.log('p', p)
                        paymentsData.push(new PaymentsData(p));
                    }
                    console.log(payments, 'paymentsData')
                    setPayments(paymentsData)
                }
            }).catch(setError);
            setDataRequested(true);
            return;
        }
        return () => { mounted.current = false }
    }, [dataRequested]);


    if (error) {
        console.debug(error);
        return <ErrorMessage error={error} />
    }

    if (!payments) {
        return <></>
    }

    return <>
        <Grid container height='100%'>

            {/* <AdminTabTitle>Cards</AdminTabTitle> */}

            <Grid item xs={10} md={10}>
                <Typography>Total Payments:&nbsp;{payments.length}</Typography>
            </Grid>

            {/* <Stack direction='row' sx={{ width: '100%' }}>
                <Typography sx={{ flexGrow: 1 }}>Total Cards:&nbsp;{cards.length}</Typography>

            </Stack> */}
            <Grid item md={2} alignItems='right'>
                {/* <Button variant='contained' onClick={() => { setShowAddUser(true) }}>Add Card</Button> */}
            </Grid>
            <Grid item xs height='100%'>

                <DataGrid
                    sx={{
                        color: theme_.dataGridTextColor
                    }}
                    columns={[
                        // { field: 'template', headerName: 'template Version', headerAlign: 'center', width: 80 },
                        { field: 'userId', headerName: 'User Id', headerAlign: 'center', width: 80 },
                        { field: 'paymentId', headerName: 'Payment Id', headerAlign: 'center', width: 150 },
                        {
                            field: 'cardsCount', headerName: 'Cards Count', headerAlign: 'center', width: 150
                        },

                        { field: 'cardType', headerName: 'Cards Type', headerAlign: 'center', width: 150 },
                        { field: 'amount', headerName: 'Amount', headerAlign: 'center', width: 200 },
                        { field: 'currency', headerName: 'Currency', headerAlign: 'center', width: 80 },

                        // { field: 'paymentDate', headerName: 'Payment Date', type: 'date', width: 250 },
                        {
                            field: 'paymentDate', type: 'dateTime', headerName: 'Payment Date', headerAlign: 'center', flex: 1, valueFormatter: params =>
                                // moment(params?.value).format("DD.MM.YYYY hh:mm A"),
                                moment(params?.value).format("DD.MM.YYYY HH:mm"),
                        },
                        { field: 'ameriaOrderStatus', headerName: 'Ameria Order Status', type: 'string', width: 250 },
                        { field: 'ameriaResponseCode', headerName: 'Ameria Response Code', type: 'string', width: 250 },


                        {
                            field: 'refund', type: 'actions', headerName: 'Refund', width: 100, renderCell: (params) => {
                                return (
                                    <>
                                        {params.row.ameriaResponseCode === '00'
                                            &&
                                            <Button variant='contained' onClick={() => setRefundPayment(params.row.paymentId as string)}>Refund</Button>
                                        }

                                    </>
                                );
                            }
                        },
                    ]}
                    rows={payments}

                    autoPageSize={true}
                    disableRowSelectionOnClick
                    getRowId={row => row.paymentId}
                />
            </Grid>

        </Grid>
        {refundPayment && <RefundDialog paymentId={refundPayment} onClose={() => { setRefundPayment(null); setDataRequested(false) }} />}
    </>;
}
